module.exports = __webpack_public_path__ + "img/pinas.7e7f836e.jpg";